/**
 * Intarsia Size Selector - Minimal Version
 * ONLY enhances labels that contain text sizes (12 x 12, 18 x 18, etc.)
 * Completely ignores everything else including color swatches
 */

class IntarsiaSizeSelector {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhance());
    } else {
      this.enhance();
    }
  }

  enhance() {
    // Only look for inputs in the "Size in inches" section
    const sizeInputs = document.querySelectorAll('input[type="radio"]');
    
    sizeInputs.forEach(input => {
      // Skip if already processed
      if (input.dataset.intarsiaProcessed) return;
      input.dataset.intarsiaProcessed = 'true';
      
      const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
      if (!label) return;
      
      // CRITICAL: Only enhance if label contains size text pattern (e.g., "12 x 12", "18 x 18")
      const labelText = label.textContent.trim();
      const isSizeLabel = /\d+\s*x\s*\d+/i.test(labelText);
      
      // Skip if not a size label OR if it has background styling (color swatches)
      if (!isSizeLabel || label.style.background || label.style.backgroundColor || label.style.backgroundImage) {
        return;
      }
      
      // This is a size label - enhance it
      label.classList.add('intarsia-size-enhanced');
      
      // Set initial state
      if (input.checked) {
        label.classList.add('intarsia-active');
      }
      
      // Use MutationObserver to watch for checked state changes (no event listeners!)
      // This way we don't interfere with ANY click handlers
      const observer = new MutationObserver(() => {
        if (input.checked) {
          // Remove active from all other size labels
          document.querySelectorAll('.intarsia-size-enhanced').forEach(l => {
            if (l !== label) l.classList.remove('intarsia-active');
          });
          // Add active to this one
          label.classList.add('intarsia-active');
        } else {
          label.classList.remove('intarsia-active');
        }
      });
      
      // Watch for attribute changes (checked state)
      observer.observe(input, { 
        attributes: true, 
        attributeFilter: ['checked'] 
      });
      
      // Also check periodically (some themes change checked without triggering mutations)
      setInterval(() => {
        if (input.checked && !label.classList.contains('intarsia-active')) {
          document.querySelectorAll('.intarsia-size-enhanced').forEach(l => {
            l.classList.remove('intarsia-active');
          });
          label.classList.add('intarsia-active');
        } else if (!input.checked && label.classList.contains('intarsia-active')) {
          label.classList.remove('intarsia-active');
        }
      }, 100);
    });
  }
}

// Initialize
if (typeof window !== 'undefined') {
  new IntarsiaSizeSelector();
}
